import { HttpHeaders } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { GalavailRestService } from 'clientwsGalavail';
import { throwError } from 'rxjs';
import { isNullOrUndefined } from 'util';
import * as i0 from "@angular/core";
import * as i1 from "clientwsGalavail";
var CabinService = /** @class */ (function () {
    function CabinService(galavailRestServce) {
        this.galavailRestServce = galavailRestServce;
    }
    CabinService.getPrice = function () {
        return 0;
    };
    CabinService.prototype.getCabinas = function (itinerario, numberOfAdults, numberOfChildren) {
        var _this = this;
        try {
            if (isNullOrUndefined(itinerario)
                || isNullOrUndefined(numberOfAdults)
                || isNullOrUndefined(numberOfChildren)) {
                throw new Error('Invalid pa');
            }
            var urlParams = itinerario.toString() + '/' + numberOfAdults.toString() + '/' + numberOfChildren.toLocaleString();
            return this.galavailRestServce.request(urlParams, 'request_itinerary_cabins', { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }).catch(function (error) {
                return _this.handleError(error);
            });
        }
        catch (error) {
            console.log('CabinaService.getCabinasss()');
            console.error(error);
            return this.handleError(error);
        }
    };
    CabinService.prototype.getAllCabins = function (itinerario, numberOfAdults, numberOfChildren, code) {
        var _this = this;
        var body = this.jsonParamsCabins(itinerario, numberOfAdults, numberOfChildren, code);
        try {
            var httpHeaders = new HttpHeaders({
                "Content-Type": "application/json"
            });
            return this.galavailRestServce
                .request('', 'request_search_cabins', {
                headers: httpHeaders
            }, body)
                .do(function () { })
                .catch(function (error) {
                return _this.handleError(error);
            });
        }
        catch (error) {
            if (isDevMode()) {
                console.log("CabinaService.getAllCabins()");
                console.error(error);
            }
            return this.handleError(error);
        }
    };
    CabinService.prototype.jsonParamsCabins = function (itinerario, numberOfAdults, numberOfChildren, code) {
        return {
            adults: numberOfAdults,
            children: numberOfChildren,
            itinerary: itinerario,
            code: code,
        };
    };
    CabinService.prototype.handleError = function (error) {
        if (isDevMode()) {
            console.log('CabinaService.getCabinasss()');
            console.error(error);
        }
        return throwError(error);
    };
    CabinService.prototype.getAppPrice = function (price, cruiseCategory, promoCode, includeAirFare, passengerType, agencyPercent) {
        if (!isNullOrUndefined(agencyPercent)) {
            return this.getPriceToPublic(price, includeAirFare, passengerType, (agencyPercent / 100));
        }
    };
    CabinService.prototype.getPriceToPublic = function (price, includeAirFare, passengerType, agencyPercent) {
        var airFare = 0;
        var cruisePricePromo = price;
        /*
    
        if (includeAirFare) {
          let airFarePriceRate: PriceRateDescriptor;
          if (passengerType === PassengerType.CHILD) {
            airFarePriceRate = PriceRateDescriptor.ChildrenAirFare;
          } else {
            airFarePriceRate = PriceRateDescriptor.AirFare;
          }
          const priceRateAirFare: PriceRate = this.priceRateService.getPriceRateByName(airFarePriceRate);
          airFare = isNullOrUndefined(priceRateAirFare) ? 0 : priceRateAirFare.valor;
        }*/
        return Math.floor((cruisePricePromo) + airFare);
    };
    CabinService.prototype.getPromoRate = function () {
        try {
        }
        catch (error) {
            console.log();
            console.error(error);
        }
    };
    CabinService.ngInjectableDef = i0.defineInjectable({ factory: function CabinService_Factory() { return new CabinService(i0.inject(i1.GalavailRestService)); }, token: CabinService, providedIn: "root" });
    return CabinService;
}());
export { CabinService };
